import { useTranslations } from 'next-intl'

import { LinkButton } from '@/components/buttons/Button'
import { FAQType } from '@/fixtures/faq'
import { formatFAQCopyKey } from '@/localization/utils'

import { Collapsible, CollapsibleItem } from './Collapsible'

import styles from './FAQModule.module.scss'

export const FAQModule: React.FC<{ faqIds: number[] }> = ({ faqIds }) => {
  const t = useTranslations()

  const faqItems: CollapsibleItem[] = faqIds.map((id) => ({
    title: t(formatFAQCopyKey(id, FAQType.Question)),
    content: t.rich(formatFAQCopyKey(id, FAQType.Answer)),
  }))

  return (
    <div className={styles.FAQModule}>
      <div className={styles.FAQWrapper}>
        <div className={styles.FAQContent}>
          <h1 className={styles.Title}>{t('lan_faq_title')}</h1>
          <p className={styles.TitleDescription}>{t('lan_faq_body')}</p>
          <Collapsible items={faqItems} />
        </div>
        <LinkButton
          additionalClasses={styles.GetMoreHelp}
          content={t('lan_faq_button')}
          type="OutlineSecondary"
          href="/help"
        />
      </div>
    </div>
  )
}
